const ACTIONS = {
  CREATE_FORM_START: 'CREATE_FORM_START',
  CREATE_FORM_COMPLETE: 'CREATE_FORM_COMPLETE',
  CREATE_FORM_ERROR: 'CREATE_FORM_ERROR',
  UPDATE_FORM_START: 'UPDATE_FORM_START',
  UPDATE_FORM_COMPLETE: 'UPDATE_FORM_COMPLETE',
  UPDATE_FORM_ERROR: 'UPDATE_FORM_ERROR',
  UPDATE_FORM_TEMPLATE_CATEGORIES: 'UPDATE_FORM_TEMPLATE_CATEGORIES',
};

const formsReducer = (state, action) => {
  const { payload } = action;

  switch (action.type) {
    case ACTIONS.CREATE_FORM_START:
      return {
        ...state,
        isCreateRequestInFlight: true,
      };
    case ACTIONS.CREATE_FORM_COMPLETE:
      return {
        ...state,
        newForm: payload.newForm,
        newFormTemplate: payload.newFormTemplate,
        isCreateRequestInFlight: false,
      };
    case ACTIONS.CREATE_FORM_ERROR:
      return {
        ...state,
        isCreateRequestInFlight: false,
      };
    case ACTIONS.UPDATE_FORM_START:
      return {
        ...state,
        isUpdateRequestInFlight: true,
      };
    case ACTIONS.UPDATE_FORM_COMPLETE:
      return {
        ...state,
        newForm: payload.newForm,
        isUpdateRequestInFlight: false,
      };
    case ACTIONS.UPDATE_FORM_ERROR:
      return {
        ...state,
        isUpdateRequestInFlight: false,
      };
    case ACTIONS.UPDATE_FORM_TEMPLATE_CATEGORIES:
      return {
        ...state,
        templateCategories: payload.templateCategories,
      };
    default:
      return state;
  }
};

export { ACTIONS, formsReducer };
